/* eslint-disable react-hooks/exhaustive-deps */
import { ForecastParamCode } from 'pleinchamp-api-client';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';
import { orderedDefaultForecastParamCodes } from './forecastParamCodes.utils';

export function getUserForecastParamCodesList(
  isAuthenticated: boolean,
  forecastFromState: ForecastParamCode[],
  defaultCodes?: ForecastParamCode[]
) {
  const filteredForecast =
    forecastFromState && forecastFromState.length && defaultCodes
      ? forecastFromState.filter(key => defaultCodes.includes(key))
      : forecastFromState;

  return isAuthenticated && filteredForecast?.length
    ? [
        ForecastParamCode.WeatherCode,
        ForecastParamCode.AirTemperatureInCelsius,
        ...filteredForecast.filter((item, pos, self) => self.indexOf(item) === pos),
      ]
    : defaultCodes || orderedDefaultForecastParamCodes;
}

export function useForecastParamCodes(defaultCodes?: ForecastParamCode[]) {
  const {
    settings: {
      preferences: { forecasts },
    },
    auth: { isAuthenticated },
  } = useSelector((state: RootState) => state);
  const [paramCodes, setParamCodes] = useState<ForecastParamCode[]>(
    defaultCodes || getUserForecastParamCodesList(isAuthenticated, forecasts)
  );

  useEffect(() => {
    setParamCodes(getUserForecastParamCodesList(isAuthenticated, forecasts, defaultCodes));
  }, [isAuthenticated, forecasts]);

  return paramCodes;
}
